<template>
    <div>
        <van-popup
            class="msg-popup"
            v-model="showPopup"
            :style="{ width: '80%' }"
            round
            get-container="body"
            @close="closePopup"
        >
            <div class="wrap">
                <div class="image" v-if="this.status != 2">
                    <img :src="tipMsg" :alt="this.title" />
                </div>
                <div class="title" :class="'title-' + this.status" v-if="this.status != 3">
                    {{ title }}
                </div>
                <div class="msg">{{ msg }}</div>
                <div class="btn-wrap">
                    <van-button type="primary" @click="close">{{ btnText }}</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { empty } from '@utils';
export default {
    name: 'MsgPopup',
    components: {},
    data() {
        return {
            showPopup: false,
            callback: null,
            closeBack: null,
            msg: '',
            status: 1,
            btnText: '知道啦',
            title: '提示'
        };
    },
    props: {},
    watch: {},
    methods: {
        show(status, title, msg, btnText, callback, closeBack) {
            this.status = status;
            if (!empty(title)) this.title = title;
            if (!empty(msg)) this.msg = msg;
            if (!empty(btnText)) this.btnText = btnText;
            this.callback = callback;
            this.closeBack = closeBack;
            this.showPopup = true;
        },
        close() {
            this.showPopup = false;
            if (typeof this.callback == 'function') {
                this.callback();
            }
        },
        closePopup() {
            if (typeof this.closeBack == 'function') {
                this.closeBack();
            }
        }
    },
    computed: {
        tipMsg: function() {
            let img = this.status == 1 ? 'success' : this.status == 3 ? 'auth' : 'fail';
            return require('@images/' + img + '-ico.png');
        }
    },
    created() {},
    beforeDestroy() {
        this.close();
    }
};
</script>
